import { render, staticRenderFns } from "./ListPacienti.vue?vue&type=template&id=2b036933"
import script from "./ListPacienti.vue?vue&type=script&lang=js"
export * from "./ListPacienti.vue?vue&type=script&lang=js"
import style0 from "./ListPacienti.vue?vue&type=style&index=0&id=2b036933&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports